import styled from 'styled-components';
import Theme from '../../../../styles/models/theme';

export const Container = styled.div<{theme?: Theme}>`
  position: fixed;
  bottom: 0;
  width: 100%;
  box-sizing: border-box;
  background-color: ${({theme}) => theme.white};
  padding: 2vw;
  border-top: 1px solid #f0f0f0;
`;
